var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.364 0c.401 0 .727.326.727.727l-.001 1.398h1.39c.84 0 1.52.663 1.52 1.48V15.52c0 .818-.68 1.481-1.52 1.481H1.52C.68 17 0 16.337 0 15.52V3.605c0-.818.68-1.481 1.52-1.481H2.91V.727c0-.401.326-.727.727-.727.402 0 .728.326.728.727l-.001 1.398h7.273V.727c0-.401.326-.727.728-.727zm2.181 5.666H1.454v9.853c0 .036.03.064.067.064h12.958c.037 0 .066-.028.066-.064V5.666zM4.858 7.083c.53 0 .96.43.96.96v.914c0 .53-.43.96-.96.96H3.87c-.53 0-.96-.43-.96-.96v-.914c0-.53.43-.96.96-.96h.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8f2ee808ca1c4e64d5d08355fb271ace.svg";
export { ForwardRef as ReactComponent };